<template>
    <div class="pricing">
      <div class="blueInfo">
        <p>基础票价：修改后立即生效，新售出车票的基础票价将按新票价执行</p>
        <p>动态调价：添加后，在生效期内的车票票价将在“基础票价金额”上再加上“动态调价金额”</p>
      </div>
      <div class="pricing-section">
        <!-- 基础票价 -->
        <el-card class="base-pricing">
          <div class="flex base-title">
            <h3>基础票价</h3>
            <el-button style="font-size: 14px;" type="text" @click="toggleBaseEdit" v-if="btnPreFn('line_rail_fee', false) && !isEditingBase">编辑</el-button>
          </div>
          <el-form>
            <el-form-item label="上次修改:">
              <div>{{ form.stationRailFee[0].updated | filterTime('YYYY/MM/DD HH:mm:SS') }}</div>
            </el-form-item>
          </el-form>
          <el-form :model="form" ref="feeForm" class="priceForm">
            <el-table border :data="form.railFee" v-loading="tableLoading">
              <el-table-column prop="startRailName" label="出发地" show-overflow-tooltip v-slot="{ row }">
                <el-tag effect="plain" :type="row.startStationType == 1 ? '' : 'success'" style="margin-right: 8px">
                  {{ row.startStationType == 1 ? "定点" : "上门" }}
                </el-tag>
                {{ row.startRailName }}
              </el-table-column>
              <el-table-column prop="endRailName" label="目的地" show-overflow-tooltip v-slot="{ row }">
                <el-tag effect="plain" :type="row.endStationType == 1 ? '' : 'success'" style="margin-right: 8px">
                  {{ row.endStationType == 1 ? "定点" : "上门" }}
                </el-tag>
                {{ row.endRailName }}
              </el-table-column>
              <el-table-column prop="fee" label="票价(元)" width="100px" v-slot="{ $index, row }">
                <el-form-item v-if="isEditingBase" :prop="'railFee.' + $index + '.fee'" :rules="[
                  { required: true, message: '请设置票价', trigger: 'blur' },
                  {
                    validator: (rule, value, callback) => {
                      // 如果调价类型为优惠，票价 - 调价金额 不能小于 0
                      if (row.premiumType == 2 && value - row.premiumFee <= 0) {
                        callback('调价后金额小于0，请重新设置');
                      } else {
                        callback();
                      }
                    }, trigger: 'blur'
                  }
                ]">
                 <!-- v-input-filter="{ min: 1, max: 999, precision: 0 }" -->
                  <el-input v-model="row.fee" v-input-filter="{ min: 1, max: 999, precision: 0 }"
                    @input="handleFeeInput($event, row)" :aria-hidden="false">
                  </el-input>
                </el-form-item>
                <span v-else>{{ row.fee }}</span>
              </el-table-column>
            </el-table>
  
            <div class="flex justify-end" v-if="isEditingBase">
              <el-button @click="baseCancel">取消</el-button>
              <el-button type="primary" @click="toggleBaseEdit" :loading="isBaseLoading">保存</el-button>
            </div>
          </el-form>
        </el-card>
        <!-- 动态调价 -->
        <el-card class="dynamic-pricing">
          <div class="flex base-title">
            <div class="flex">
                <h3>动态调价</h3>
            <el-tag v-if="form.premiumStartTime" size="mini" style="margin-left: 8px;"
          :type="form.premiumStatus == 1 ? 'success' : 'info'">
          {{ form.premiumStatus == 1 ? '生效中' : '已失效' }}
        </el-tag>
            </div>
            <el-switch v-if="btnPreFn('line_rail_fee', false) && !isDynamicEdit" v-model="form.premiumStatus" :active-value="1" :inactive-value="2"
              @change="toggleDynamicEdit"></el-switch>
          </div>
          <el-form :model="dynamicForm" ref="dynamicForm">
            <el-form-item label="调价日期:" prop="dateRange" :rules="{
              required: isDynamicEdit ? true : false,
              message: '请选择调价日期',
              trigger: 'blur',
            }">
              <el-date-picker v-if="isDynamicEdit" v-model="dynamicForm.dateRange" type="daterange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false"
                :default-time="['00:00:00', '23:59:59']" :picker-options="{
                  disabledDate(time) {
                    return time.getTime() <= Date.now();
                    // return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                  }
                }" style="width: 330px;">
              </el-date-picker>
              <div v-else>{{ this.form.premiumStartTime | filterTime('YYYY/MM/DD') }} ~ {{ this.form.premiumEndTime |
                filterTime('YYYY/MM/DD') }}</div>
            </el-form-item>
          </el-form>
  
          <el-table :data="form.railFee" border v-loading="tableLoading">
            <el-table-column prop="type" label="调价类型">
              <template v-slot="{ row }">
                <el-radio-group v-model="row.premiumType" @change="premiumTypeChange(row)" class="flex"
                  :aria-hidden="false" v-if="isDynamicEdit">
                  <el-radio :label="1" style="margin-right: 8px">溢价</el-radio>
                  <el-radio :label="2">优惠</el-radio>
                </el-radio-group>
                <span v-else :style="{ color: row.premiumType == 1 ? '#FF9900' : '#409EFF' }">{{ row.premiumType == 1 ?
                  '溢价' : '优惠' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="调价金额(元)">
              <template v-slot="{ row }">
                <el-input v-model="row.premiumFee" @input="handleAdjustInput($event, row)" placeholder="请输入"
                  v-if="isDynamicEdit">
                </el-input>
                <span v-else :style="{ color: row.premiumType == 1 ? '#FF9900' : '#409EFF' }">{{ row.premiumFee }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="finalAmount" label="调价后金额(元)">
              <template v-slot="{ row }">
                <span v-if="form.premiumStatus == 1" :style="{ color: row.premiumType == 1 ? '#FF9900' : '#409EFF' }">{{
                  row.finalAmount }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="flex justify-end" style="margin-top: 20px;" v-if="isDynamicEdit">
            <el-button @click="dynamicCancel">取消</el-button>
            <el-button type="primary" @click="saveDynamicPrice" :loading="isSaving">保存</el-button>
          </div>
        </el-card>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isEditingBase: false,
        form: {
          stationRailFee: [{
            updated: null
          }],
          railFee: [],
          updated: '',
          stationVoList: [],
          isReturn: false,
        },
        isBaseLoading: false,
  
        isDynamicEdit: false,
        isSaving: false,
        dynamicForm: {
          dateRange: [],
        },
        railFeeOld: [],
        tableLoading: false,
      };
    },
    async created() {
      await this.getLineData();
    },
    methods: {
      /**
       * 取消编辑基础票价,重置数据
       */
      baseCancel() {
        this.isEditingBase = false;
        this.getLineData();
      },
  
      /**
       * 保存修改后的基础票价
       */
      saveChangePrice() {
        this.$refs.feeForm.validate(async (valid, invalidFields) => {
          if (valid) {
            const url = "/api/v1/manage/line/railFee";
            let params = {
              // id: this.$route.query.id,
              // railFee: JSON.stringify(this.form.railFee),
              ...this.form,
              railFee: JSON.stringify(this.form.railFee),
            };
            this.isBaseLoading = true;
            const { code } = await this.$axios.put(url, params);
            if (code === 1) {
              this.$message.success("修改票价成功");
              this.baseCancel();
            }
            this.isBaseLoading = false;
          } else {
            this.$message.error(invalidFields[Object.keys(invalidFields)[0]][0].message);
          }
        });
      },
  
      /**
       * 切换基础票价编辑状态
       * 如果当前是编辑状态,则保存修改
       */
      toggleBaseEdit() {
        if (this.isEditingBase) {
          // 保存逻辑
          this.saveChangePrice();
          return;
        }
        this.isEditingBase = !this.isEditingBase;
        // 如果动态调价可编辑，则把动态调价改为不可变编辑
        if (this.isDynamicEdit) {
          this.isDynamicEdit = false
          this.form.premiumStatus = 2
          this.form.railFee = this.railFeeOld.map(item => {
            return { ...item }
          });
        }
      },
  
      /**
       * 获取线路票价数据
       */
      async getLineData() {
        this.tableLoading = true;
        let url = "/api/v1/manage/line/" + this.$route.query.id;
        let { code, data } = await this.$axios.get(url);
        if (code === 1 && data.stationVoList) {
          // 起点终点交叉处理函数
          let crossFn = (way, ...arrs) => {
            // 单程交叉 arr1>起点列表  arr2>终点列表
            let oneWay = arrs.reduce((arr1, arr2) => {
              return arr1.flatMap((e) => {
                return arr2.map((e2) => {
                  return {
                    startStationType: e.stationType,
                    endStationType: e2.stationType,
                  };
                });
              });
            });
  
            return oneWay;
          };
          let railFee = crossFn(
            data.isReturn,
            data.stationVoList[0].stationRail,
            data.stationVoList[1].stationRail
          );
          this.railFeeOld = data.stationRailFee.map((item, index) => ({
            ...railFee[index],
            ...item,
            premiumType: item.premiumType || 1,
            premiumFee: item.premiumFee || 0, 
            finalAmount: item.premiumType == 1 ? parseFloat(item.fee) + parseFloat(item.premiumFee || 0) : parseFloat(item.fee) - parseFloat(item.premiumFee || 0),
          }))
          this.form = {
            ...data,
            railFee: data.stationRailFee.map((item, index) => ({
              ...railFee[index],
              ...item,
              premiumType: item.premiumType || 1,
              premiumFee: item.premiumFee || 0,
              finalAmount: item.premiumType == 1 ? parseFloat(item.fee) + parseFloat(item.premiumFee || 0) : parseFloat(item.fee) - parseFloat(item.premiumFee || 0),
            }))
          };
          this.dynamicForm.dateRange =  this.form.premiumStartTime && this.form.premiumEndTime ? [
           new Date(this.form.premiumStartTime * 1000), new Date(this.form.premiumEndTime * 1000)
          ] : [];
        }
        this.tableLoading = false;
      },
  
      // 动态调价可编辑
      toggleDynamicEdit(value) {
        if (value == 1) {
          // // 如果基础票价可编辑，则把基础票价改为不可变编辑
          if (this.isEditingBase) {
            this.isEditingBase = false;
            // 把票价改为修改之前的
            this.form.railFee = this.railFeeOld.map(item => {
              return { ...item }
            });
          }
          this.$nextTick(() => {
            this.isDynamicEdit = true;
            this.form.premiumStatus = 1;
          })
        } else {
          this.$confirm('停用动态调价后，车票价格仅按基础票价计算', '停用动态调价', {
            confirmButtonText: '确 认',
            cancelButtonText: '取 消',
            type: 'warning',
          }).then(async () => {
            let url = "/api/v1/manage/line/railFee/premium";
            let params = {
              id: this.form.id,
              premiumStatus: this.form.premiumStatus,
              premiumStartTime: this.form.premiumStartTime,
              premiumEndTime: this.form.premiumEndTime,
              railPremiumFee: JSON.stringify(this.form.railFee.map(item => ({
                id: item.id,
                premiumType: item.premiumType,
                premiumFee: item.premiumFee,
                fee: item.fee
              })))
            };
            const { code } = await this.$axios.put(url, params);
            if (code === 1) {
              this.$message.success('动态调价已失效');
              this.dynamicCancel();
            }
          }).catch(() => {
            this.form.premiumStatus = 1;
          });
        }
      },
      premiumTypeChange(row) {
        // 如果类型为优惠，调价金额 不能大于票价
        if (row.premiumType == 2 && row.premiumFee >= row.fee) {
          row.premiumFee = row.fee - 1;
        }
        this.calculateFinalPrice(row)
      },
      handleFeeInput(event, row) {
        this.calculateFinalPrice(row);
      },
  
      /**
       * 处理调价输入
       * @param {Event} event - 输入事件
       * @param {Object} row - 当前行数据
       */
      handleAdjustInput(event, row) {
        // 确保输入的值是数字并在0到999之间
        let value = event.replace(/[^\d]/g, '');
        // let value = event;
        value = Math.min(Math.max(value, 0), row.premiumType == 1 ? 999 : row.fee - 1);
        row.premiumFee = value;
        this.calculateFinalPrice(row);
      },
  
      /**
       * 计算最终票价
       * @param {Object} row - 当前行数据
       */
      calculateFinalPrice(row) {
        row.finalAmount = row.premiumType == 1 ? parseFloat(row.fee || 0) + parseFloat(row.premiumFee || 0) : parseFloat(row.fee || 0) - parseFloat(row.premiumFee || 0);
      },
      dynamicCancel() {
        this.isDynamicEdit = false;
        this.form.premiumStatus = 2;
        this.getLineData();
      },
      /**
       * 保存动态票价
       */
      async saveDynamicPrice() {
        this.$refs.dynamicForm.validate(async (valid) => {
          if (valid) {
            let url = "/api/v1/manage/line/railFee/premium";
            let params = {
              id: this.form.id,
              premiumStatus: this.form.premiumStatus,
              premiumStartTime: new Date(this.dynamicForm.dateRange[0]).getTime() / 1000,
              premiumEndTime: new Date(this.dynamicForm.dateRange[1]).getTime() / 1000,
              railPremiumFee: JSON.stringify(this.form.railFee.map(item => ({
                id: item.id,
                premiumType: item.premiumType,
                premiumFee: item.premiumFee,
                fee: item.fee
              })))
            };
            this.isSaving = true;
            const { code } = await this.$axios.put(url, params);
            if (code === 1) {
              this.$message.success('动态调价已生效');
              this.dynamicCancel();
            }
            this.isSaving = false;
          }
        });
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .pricing {
  
    .pricing-section {
      display: flex;
      justify-content: space-between;
  
      .base-pricing,
      .dynamic-pricing {
        width: 60%;
  
        .justify-end {
          margin-top: 20px;
          justify-content: flex-end;
        }
  
        .base-title {
          height: 28px;
          justify-content: space-between;
        }
  
        .base-update {
          margin: 24px 0;
          height: 28px;
        }
  
        /deep/ .el-form-item {
          margin-bottom: 0;
        }
      }
  
      .dynamic-pricing {
        width: 38%;
      }
    }
  
    /deep/ .cell {
      line-height: 28px;
    }
  }
  </style>